import {CanActivateFn, Router} from "@angular/router";
import {inject} from "@angular/core";
import {AuthService} from "src/app/modules/auth/services/auth.service";

/**
 * Redirects logged-in users who have not completed onboarding yet to the
 * onboarding flow. The `/onboarding` URL itself is excluded to avoid a loop, so
 * the guard can be applied safely to any authenticated route.
 */
export const onboardingGuard: CanActivateFn = (_route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const user = authService.user;
  if (user && !user.onboardedAt && !state.url.startsWith("/onboarding")) {
    return router.createUrlTree(["/onboarding"], {
      queryParams: {redirectTo: state.url},
    });
  }

  return true;
};
